// ========== 大图加载器模块 ==========
// 策略：国内源和国外源同时发起请求，谁先成功就用谁
// 都失败则1.5s总超时兜底国内源

const CONFIG = {
    CN: 'https://birchcloud.s3.bitiful.net/website_cn/wallpaper/wallpaper-1.webp',
    GLOBAL: 'https://ru.serverspace.store/v1/AUTH_6b80e0eccd09480a9804277c171def67/enterprise/china-icp-site/site-1/wallpaper-1.webp'
};

/**
 * 初始化背景图片加载
 */
export function initImageLoader() {
    const banner = document.getElementById('banner');
    const img = document.querySelector('.hero-bg-image');
    
    if (!banner || !img) {
        console.warn('[ImageLoader] Banner or image element not found');
        return;
    }

    let resolved = false;
    let cnFailed = false;
    let globalFailed = false;

    // 应用图片 URL
    function applyImage(url) {
        img.src = url;
        
        // 图片加载成功
        img.onload = function() {
            img.classList.add('loaded');
            console.log('[ImageLoader] Image loaded successfully:', url);
        };
        
        // 图片加载失败
        img.onerror = function() {
            img.classList.add('error');
            banner.classList.add('image-error');
            console.error('[ImageLoader] Image failed to load:', url);
        };
    }

    // 兜底：两个都失败时使用国内源
    function tryFallback() {
        if (!resolved && cnFailed && globalFailed) {
            resolved = true;
            console.warn('[ImageLoader] Both sources failed, using CN fallback');
            applyImage(CONFIG.CN);
        }
    }

    // 尝试加载图片
    function tryLoad(url, label) {
        const testImg = new Image();
        
        testImg.onload = function() {
            if (!resolved) {
                resolved = true;
                console.log('[ImageLoader] Source succeeded:', label);
                applyImage(url);
            }
        };
        
        testImg.onerror = function() {
            console.warn('[ImageLoader] Source failed:', label);
            if (label === 'CN') {
                cnFailed = true;
            } else {
                globalFailed = true;
            }
            tryFallback();
        };
        
        testImg.src = url;
    }

    // 并行加载两个源
    tryLoad(CONFIG.CN, 'CN');
    tryLoad(CONFIG.GLOBAL, 'GLOBAL');

    // 1.5s 总超时兜底
    setTimeout(function() {
        if (!resolved) {
            resolved = true;
            console.warn('[ImageLoader] Timeout reached, using CN fallback');
            applyImage(CONFIG.CN);
        }
    }, 1500);
}
